//登录保存信息
export const GET_USER_INFO = 'GET_USER_INFO'
//用户是否登录
export const USER_LOGIN = 'USER_LOGIN'
//获取系统列表
export const GET_PROJECTS = 'GET_PROJECTS'
//应用列表
export const GET_ALL_APP = 'GET_ALL_APP'
//系统id
export const FILTER_PROJECT_ID = 'FILTER_PROJECT_ID'
//系统类别
export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY'